<template>
  <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
    <div class="bg-white dark:bg-gray-900 p-6 rounded-lg w-full max-w-3xl">
      <h2 class="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Create Ticket</h2>

      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Tech</label>
          <select v-model="form.tech_id" :class="[
            'w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white',
            validationErrors.tech_id ? 'border-red-500' : 'dark:border-gray-700'
          ]">
            <option value="0">Delegator</option>
            <template v-for="(group, label) in groupedTechnicians" :key="label">
              <optgroup v-if="label" :label="label">
                <option v-for="tech in group" :key="tech.id" :value="tech.id">
                  {{ tech.name }}
                </option>
              </optgroup>
              <template v-else>
                <option v-for="tech in group" :key="tech.id" :value="tech.id">
                  {{ tech.name }}
                </option>
              </template>
            </template>
          </select>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Description</label>
          <textarea v-model="form.description" :class="[
            'w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white',
            validationErrors.description ? 'border-red-500' : 'dark:border-gray-700'
          ]" rows="3">
  </textarea>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Ticket Type</label>
          <select v-model="form.tickettypeid" :class="[
            'w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white',
            validationErrors.tickettypeid ? 'border-red-500' : 'dark:border-gray-700'
          ]">
            <option value="" disabled>Select type</option>
            <option v-for="type in ticketTypes" :key="type.id" :value="type.id">{{ type.description }}</option>
          </select>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Est. Time (hrs)</label>
            <input v-model="form.est_time" type="number" step="0.1" :class="[
              'w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white',
              validationErrors.est_time ? 'border-red-500' : 'dark:border-gray-700'
            ]" />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Promised Date</label>
            <input v-model="form.promised_date" type="date" :class="[
              'w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white',
              validationErrors.promised_date ? 'border-red-500' : 'dark:border-gray-700'
            ]" />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">Promised Time</label>
            <select v-model="form.promised_time" :class="[
              'w-full px-3 py-2 border rounded dark:bg-gray-800 dark:text-white',
              validationErrors.promised_time ? 'border-red-500' : 'dark:border-gray-700'
            ]">
              <option v-for="t in times" :key="t" :value="t">{{ t }}</option>
            </select>
          </div>
        </div>


        <div class="flex space-x-6 items-center">
          <label class="inline-flex items-center">
            <input type="checkbox" v-model="form.ticket_tech_notify"
              class="h-4 w-4 text-blue-600 border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600" />
            <span class="ml-2 text-sm text-gray-700 dark:text-gray-200">Notify Tech</span>
          </label>
          <label class="inline-flex items-center">
            <input type="checkbox" v-model="form.ticket_client_notify"
              class="h-4 w-4 text-blue-600 border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600" />
            <span class="ml-2 text-sm text-gray-700 dark:text-gray-200">Notify Client</span>
          </label>
          <label class="inline-flex items-center">
            <input type="checkbox" v-model="form.unpublished"
              class="h-4 w-4 text-blue-600 border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600" />
            <span class="ml-2 text-sm text-gray-700 dark:text-gray-200">DO NOT Publish</span>
          </label>
          <label class="inline-flex items-center">
            <input type="checkbox" v-model="form.internal"
              class="h-4 w-4 text-blue-600 border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600" />
            <span class="ml-2 text-sm text-gray-700 dark:text-gray-200">Internal</span>
          </label>
        </div>

        <div class="flex justify-end space-x-3 mt-6">
          <button @click="$emit('close')"
            class="bg-gray-400 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded dark:bg-red-500 dark:hover:bg-red-700">
            Cancel
          </button>
          <button @click="createTicket"
            class="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded">
            Save Ticket
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    techs: {
      type: Array,
      required: true
    },
    ticketTypes: {
      type: Array,
      required: true
    },
    userId: {
      type: [String, Number],
      required: true
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.form.tech_id = this.userId?.toString();

        if (!this.form.promised_date) {
          const phoenixToday = moment.tz('America/Phoenix').format('YYYY-MM-DD');
          this.form.promised_date = phoenixToday;
        }
      }
    }
  },
  computed: {
    groupedTechnicians() {
      const groups = {};
      const ungrouped = [];

      this.techs.forEach(tech => {
        if (!tech.deptId) {
          ungrouped.push({ id: tech.id, name: tech.name });
          return;
        }

        let groupKey = '';
        if (tech.deptId === "External Tech") {
          groupKey = "External Tech";
        } else if (tech.details) {
          groupKey = tech.details;
        } else {
          groupKey = "Other Department";
        }

        if (!groups[groupKey]) {
          groups[groupKey] = [];
        }

        let displayName = tech.name;
        if (tech.deptId === "External Tech" && tech.details) {
          displayName += ` (${tech.details})`;
        }

        groups[groupKey].push({
          id: tech.id,
          name: displayName,
        });
      });

      if (ungrouped.length > 0) {
        groups[""] = ungrouped;
      }

      let keys = Object.keys(groups).filter(k => k !== "External Tech").sort((a, b) => {
        if (a === "") return -1;
        if (b === "") return 1;
        return a.localeCompare(b);
      });

      if (groups["External Tech"]) {
        keys.push("External Tech");
      }

      const orderedGroups = {};
      keys.forEach(key => {
        orderedGroups[key] = groups[key];
      });

      return orderedGroups;
    }
  },
  data() {
    return {
      form: {
        tech_id: '',
        description: '',
        tickettypeid: '',
        est_time: 0,
        promised_date: '',
        promised_time: '09:00',
        ticket_tech_notify: false,
        ticket_client_notify: false,
        unpublished: false,
        internal: false
      },
      validationErrors: {},
      times: [
        '07:00', '08:00', '09:00', '10:00',
        '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'
      ]
    };
  },
  methods: {
    validateForm() {
      const errors = {};

      if (!this.form.tech_id) errors.tech_id = true;
      if (!this.form.description.trim()) errors.description = true;
      if (this.form.tickettypeid === '' || this.form.tickettypeid === null) {
        errors.tickettypeid = true;
      }
      if (this.form.est_time === '' || this.form.est_time === null || this.form.est_time < 0 || isNaN(this.form.est_time)) {
        errors.est_time = true;
      }
      if (!this.form.promised_date) errors.promised_date = true;
      if (!this.form.promised_time) errors.promised_time = true;

      this.validationErrors = errors;
      return Object.keys(errors).length === 0;
    },
    createTicket() {
      const valid = this.validateForm();
      console.log("Validation Errors:", this.validationErrors); // Debug line
      if (!valid) return;
      this.$emit('created', {
        techid: this.form.tech_id,
        description: this.form.description,
        tickettypeid: this.form.tickettypeid,
        est_time: this.form.est_time,
        promised_date: this.form.promised_date,
        promised_time: this.form.promised_time,
        ticket_tech_notify: this.form.ticket_tech_notify ? 1 : 0,
        ticket_client_notify: this.form.ticket_client_notify ? 1 : 0,
        unpublished: this.form.unpublished ? 1 : 0,
        internal: this.form.internal ? 1 : 0
      });
      this.$emit('close');
    }
  }
};
</script>
